// Section
export const SET_VALUES_SECTION = 'setValuesSection'
export const CLEAR_VALUES_SECTION = 'clearValuesSection'
// Document
export const SET_VALUES_DOCUMENT = 'setValueDocument'
export const CLEAR_VALUES_DOCUMENT = 'clearValuesDocument'
// Email
export const SET_VALUES_EMAIL = 'setValueEmail'
export const CLEAR_VALUES_EMAIL = 'clearValuesEmail'
// Evaluator
export const SET_VALUES_EVALUATOR = 'setValueEvaluator'
export const CLEAR_VALUES_EVALUATOR = 'clearValuesEvaluator'

// Catalogs
export const SET_CATALOG = 'setValueCatalog'
// Admins
export const SET_VALUES_ADMIN = 'setValueAdmin'
export const CLEAR_VALUES_ADMIN = 'clearValuesAdmin'
// profiles
export const SET_VALUES_PROFILE = 'setValueProfile'
export const CLEAR_VALUES_PROFILE = 'clearValuesProfile'

export const SET_SESSION_PERMISSION = 'setSessionPermission'

export const SET_VALUES_SETTINGS = 'setValueSettings'

// Survays
export const SET_VALUES_DIGITAL_FORM = 'setValueSurvays'
export const CLEAR_VALUES_DIGITAL_FORM = 'clearValuesSurvays'
